import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../config";
import Testimonials from "../../components/Testimonials";
import "./PaginaCursoPublico.css";
import { FALLBACK_IMAGE_SRC } from "../../utils/placeholderImage";
import CourseHeroImage from "../../components/CourseHeroImage";
import { isCourseAvailableForPurchase, isCourseComingSoon } from "../../utils/coursePurchaseState";
import { formatCourseDurationLabel } from "../../utils/formatCourseDurationLabel";
import CourseDescriptionContent from "../../components/CourseDescriptionContent";
import { readCartCourses, upsertCartCourse } from "../../utils/cartCourseSelection";
import { useOwnedCourseIds } from "../../hooks/useOwnedCourseIds";
import { isCourseOwnedByUser } from "../../utils/ownedCourseIds";
import { getMessage } from "../../data/locales";

const PaginaCursoPublico = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [curso, setCurso] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje] = useState("");
  const [enCarrito, setEnCarrito] = useState(false);
  const { ownedCourseIds, ownershipReady } = useOwnedCourseIds();

   useEffect(() => {
    const obtenerCurso = async () => {
      try {
        const res = await fetch(`${API_URL}/cursos/${id}`);
        if (!res.ok) throw new Error("No encontrado");
        const data = await res.json();
        setCurso(data);

        const carrito = readCartCourses();
        const isAlreadyInCart = carrito.some(c => c._id === data._id);
        if (isAlreadyInCart) {
          upsertCartCourse(data);
        }
        setEnCarrito(isAlreadyInCart);
      } catch (err) {
        console.error(err);
      } finally {
        setCargando(false);
      }
    };
    obtenerCurso();
  }, [id]);

  if (cargando) return <p>Cargando curso…</p>;
  if (!curso)    return <p>Curso no encontrado.</p>;

  const canPurchase = isCourseAvailableForPurchase(curso);
  const comingSoon = isCourseComingSoon(curso);
  const alreadyOwned = ownershipReady && isCourseOwnedByUser(curso._id, ownedCourseIds);
  const descripcion = curso.descripcion || "";

  return (
    <div className="pagina-curso-publico">
      {mensaje && <div className="mensaje-flash">{mensaje}</div>}

      <div className="curso-contenedor">
        <CourseHeroImage
          src={curso.imagen || FALLBACK_IMAGE_SRC}
          alt={curso.titulo}
          className="curso-imagen"
        />
        <div className="curso-info">
          <h1>{curso.titulo}</h1>
          <div id="curso-descripcion-panel" className="curso-descripcion-block">
            <CourseDescriptionContent
              html={descripcion}
              className="descripcion"
            />
          </div>
          <div className="DuraYPrec">
          <p className="Dura"><strong>Duración:</strong> {formatCourseDurationLabel(curso.duracion)}</p>
          <p className="precio">{curso.precioFinal} €</p>
          </div>
          {!ownershipReady ? (
            <button type="button" className="btn-anadir-carrito" disabled>
              {getMessage("checkout.checkingAccess")}
            </button>
          ) : alreadyOwned ? (
            <>
              <p className="curso-ya-adquirido" role="status">
                {getMessage("checkout.alreadyOwnedCourse")}
              </p>
              <button
                type="button"
                className="btn-anadir-carrito"
                onClick={() => navigate(`/usuario/curso/${curso._id}`)}
              >
                {getMessage("checkout.goToCampus")}
              </button>
            </>
          ) : comingSoon ? (
            <button type="button" className="btn-anadir-carrito btn-anadir-carrito--soon" disabled>
              Próximamente
            </button>
          ) : enCarrito ? (
            <button type="button" disabled className="btn-carrito-disabled">
              Ya está en el carrito
            </button>
          ) : (
            <button
              type="button"
              className="btn-anadir-carrito"
              disabled={!canPurchase}
              onClick={() => {
                if (!canPurchase) return;
                upsertCartCourse(curso);
                setEnCarrito(true);
                setMensaje("✅ Curso añadido al carrito");
                setTimeout(() => {
                  setMensaje("");
                  navigate("/pago");
                }, 1500);
              }}
            >
              Añadir al carrito
            </button>
          )}
        </div>
      </div>
      <Testimonials cursoId={curso._id} />
    </div>
  );
};

export default PaginaCursoPublico;
